  
 
 
    <h2 mat-dialog-title>
         Please enter email
        <!-- <button mat-icon-button (click)="closePopUp()">
        <mat-icon>close</mat-icon>
        </button> -->
    </h2>
    
  <mat-dialog-content>
    <mat-form-field class="example-full-width">
      <mat-label>Email <span style="color:red"></span></mat-label>
      <input matInput placeholder="Enter email" required type="email" (input)="getEmailVerified()"
      [(ngModel)]="authenticationEmail"/>        
    </mat-form-field> 
  
  </mat-dialog-content>
  
 

  <mat-dialog-actions class="dialog-actions">
    <!-- <button mat-button (click)="closePopUp()">Cancel</button> -->
    <button mat-flat-button color="primary" (click)="verifyEmail()">Save</button>
  </mat-dialog-actions>
  

  

  




